import store from "utils/store.js";

export default function setH1(events) {
  store.dispatch({
    type: "h1/set",
    payload: events,
  });
}
